import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getGridData } from 'src/app/shared/selectors/grid.selectors';

export const getCheckbooksState = createSelector(getDragonflyState, (state) => state?.searchCheckbooks);

export const getPanelExpansion = createSelector(getCheckbooksState, (state) => state?.panelExpanded);

export const getCheckbooksTypes = createSelector(getCheckbooksState, (state) => state?.checkbooksTypes);

export const getSelectedTypeId = createSelector(getCheckbooksState, (state) => state?.selectedTypeId);

export const getCardNumber = createSelector(getCheckbooksState, (state) => state?.cardNumber);

export const getGivenDate = createSelector(getCheckbooksState, (state) => state?.givenDate);

export const getGivenDateFormat = createSelector(getCheckbooksState, (state) => state?.givenDateFormat);

export const getCheckbookCode = createSelector(getCheckbooksState, (state) => state?.checkbookCode);

export const getInvoiceNumber = createSelector(getCheckbooksState, (state) => state?.invoiceNumber);

export const getGivenStatus = createSelector(getCheckbooksState, (state) => state?.givenStatus);

export const getLoyaltyMemberId = createSelector(getCheckbooksState, (state) => state?.loyaltyMemberId);

export const getIsCheckbookValidForAssign = createSelector(getGridData, (data) => {
  return (data ?? []).map((m) => {
    return m.given === false ? true : false;
  });
});

export const getIsCheckbookValidForUnassign = createSelector(getGridData, (data) => {
  return (data ?? []).map((m) => {
    return m.given === true ? true : false;
  });
});

export const getAssignCheckbookRoleExist = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('bookcoupongroup.action.assign') ? true : false,
);

export const getShowAssignBtn = createSelector(getAssignCheckbookRoleExist, getIsCheckbookValidForAssign, (a, b) => {
  const result = (b ?? []).map((m) => (m === true && a === true ? true : false));
  return result;
});

export const getCouponSet = createSelector(getCheckbooksState, (state) => state?.couponSet);

export const getShowUnassignBtn = createSelector(
  getAssignCheckbookRoleExist,
  getIsCheckbookValidForUnassign,
  (a, b) => {
    const result = (b ?? []).map((m) => (m === true && a === true ? true : false));
    return result;
  },
);
